import { render, staticRenderFns } from "./AddictiveStuffClientsDiseases.vue?vue&type=template&id=60ef65de&"
import script from "./AddictiveStuffClientsDiseases.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientsDiseases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports